import bangladesh_banner from "./images/bangladesh.svg";
import bangladesh_flag from "./images/bangladesh_flag.svg";
import clean_drinking_water from "./images/clean_drinking_water.png";
import clean_drinking_water2 from "./images/clean_drinking_water.svg";
import education from "./images/education.png";
import education2 from "./images/education.svg";
import food_and_nutrition from "./images/food_and_nutrition.png";
import food_and_nutrition2 from "./images/food_and_nutrition.svg";
import healthcare from "./images/healthcare.png";
import healthcare2 from "./images/healthcare.svg";
import india_banner from "./images/india.svg";
import india_flag from "./images/india_flag.svg";
import nepal_banner from "./images/nepal.svg";
import nepal_flag from "./images/nepal_flag.png";
import pakistan_banner from "./images/pakistan.svg";
import pakistan_flag from "./images/pakistan_flag.svg";

const joinTheCauseData = [
    {
        id: 1,
        title: "Clean Drinking Water",
        description: `Water is a fundamental necessity for life. Unfortunately, every day, 3,400 innocent children under the age of 5 are losing their lives due to the lack of clean drinking water and proper sanitation. It's a tragedy that we have the power to change with your support. Together, we can help provide access to clean water, saving young lives and giving children a brighter future. By joining forces, we can make a real difference and create a world where every child has the right to clean water, good health, and a hopeful tomorrow. Be a part of the solution and make a difference in the lives of children in need. Your support can bring a brighter future, starting with access to clean drinking water.`,
        image: clean_drinking_water,
    },
    {
        id: 2,
        title: "Food & Nutrition",
        description: `Ending childhood hunger is within our reach, and it all starts with small acts of kindness. At Desi Fresh, we believe that every child deserves a healthy meal, and it's easier to make a difference than you might think. By choosing to shop with us, you'll not only be treating yourself to the best in multicultural cuisine, but also fueling the future of the next generation. With every purchase, you'll be providing the nourishment and energy that growing minds and bodies need to thrive. Empower children with every purchase from Desi Fresh,
        and experience the power of giving.`,
        image: food_and_nutrition,
    },
    {
        id: 3,
        title: "Education",
        description: `Education is the key to unlocking a better future, yet so many children are still left behind due to poverty and lack of access. It's time for us to come together and make a difference. Join the movement for quality education for all children. By taking small steps, like supporting organizations that prioritize education, we can have a huge impact. You have the power to change a child's life and set them on a path to success. Let's come together and give every child the chance they deserve. Join the movement for quality education for all children.`,
        image: education,
    },
    {
        id: 4,
        title: "Healthcare",
        description: `Every child deserves a chance to grow up healthy, strong, and happy. But unfortunately, there are 400 million children in the world today who suffer from underprivileged health conditions, lack access to basic healthcare, and face insurmountable odds to reach their full potential. With your support, we can change that. By giving to our Desi Hands initiative, you can help provide vital healthcare to kids in need, improve their mental health, and ensure they have the chance to receive an education. Join us in giving every child the chance to live their best life,
            one donation at a time.`,
        image: healthcare,
    },
];

const empowerFutureData = [
    {
        id: 1,
        title: "Clean Drinking Water",
        image: clean_drinking_water2,
    },
    {
        id: 2,
        title: "Food & Nutrition",
        image: food_and_nutrition2,
    },
    {
        id: 3,
        title: "Education",
        image: education2,
    },
    {
        id: 4,
        title: "Healthcare",
        image: healthcare2,
    },
];

const makeDifferenceData = [
    {
        id: 1,
        banner: india_banner,
        country: "India",
        flag: india_flag,
    },
    {
        id: 2,
        banner: pakistan_banner,
        country: "Pakistan",
        flag: pakistan_flag,
    },
    {
        id: 3,
        banner: bangladesh_banner,
        country: "Bangladesh",
        flag: bangladesh_flag,
    },
    {
        id: 4,
        banner: nepal_banner,
        country: "Nepal",
        flag: nepal_flag,
    },
];

const faqData = [
    {
        id: 1,
        question: "What is Desi Hands?",
        answer: "Desi Hands is a corporate social responsibility program run by Desi Fresh Multicultural Grocery store that supports underprivileged children in need.",
    },
    {
        id: 2,
        question: "How does Desi Hands work?",
        answer: "Desi Fresh donates a portion of its profits to support various initiatives and organizations that help underprivileged children in need.",
    },
    {
        id: 3,
        question: "Who do Desi Hands support?",
        answer: "Desi Hands supports children in need in India, Pakistan, Bangladesh, Nepal, and Sri Lanka.",
    },
    {
        id: 4,
        question: "How can I get involved with Desi Hands?",
        answer: "You can show your support for Desi Hands by shopping at Desi Fresh and spreading the word about our community outreach program. You can also directly support underprivileged children by making a donation to an organization we support.",
    },
    {
        id: 5,
        question: "How do I know where my money is going?",
        answer: "Desi Fresh is transparent about where its donations go, and provides updates on the initiatives and organizations it supports through Desi Hands.",
    },
    {
        id: 6,
        question: "How can I nominate an organization for support from Desi Hands?",
        answer: "Desi Fresh welcomes nominations for organizations that are making a difference for underprivileged children in need. To nominate an organization, please contact us and provide details about the organization and the work they do.",
    },
    {
        id: 7,
        question: "Does Desi Fresh have a commitment to sustainability?",
        answer: "Yes, at Desi Fresh, we are committed to making a positive impact on the environment. We use eco-friendly packaging materials, and we actively work to reduce our carbon footprint and waste. We also support farmers and suppliers to promote sustainable agriculture practices.",
    },
    {
        id: 8,
        question: "What is the Desi Family Loyalty Rewards program?",
        answer: "At Desi Fresh, we value our customers and reward their loyalty. Our Desi Family Loyalty Rewards program allows customers to earn points for every purchase made in-store or online. These points can be redeemed for discounts on future purchases, special promotions, and other rewards. Join now and start earning rewards for your loyalty to Desi Fresh!",
    },
    {
        id: 9,
        question: "What is Desi Hands, and how can you be a part of it?",
        answer: "At Desi Fresh, we believe in giving back and making a positive impact in our communities. That's why we've created Desi Hands, our community outreach program that supports charitable organizations in India, Pakistan, Bangladesh, Nepal, and Sri Lanka. By choosing to shop with us, you're not only filling your pantry, but you're also supporting children in need by providing them with food, education, and healthcare. Let's work together to create a brighter future for those who need it most. Join the Desi Hands movement today and be a part of something truly meaningful.",
    },
    {
        id: 10,
        question: "Can I suggest new products?",
        answer: "Yes! We welcome product suggestions from our customers. Contact us to recommend new items.",
    },
];

export { empowerFutureData, faqData, joinTheCauseData, makeDifferenceData };
